class Formulaire {

  constructor(){
    this.formulaireChamp       = document.querySelector('#js-formulaire--filter');
    this.formulaireButton = document.querySelector('#js-formulaire--filter--btn');
    this._init();
  }

  _init(){

    document.addEventListener('DOMContentLoaded', (event) => {

      jQuery('#js-formulaire--filter--btn').parent().css('display','none');
      if(this.formulaireChamp){
        this.formulaireChamp.addEventListener('change', 
          this._submitFormulaire.bind(this),
          false
        );
      }

    });
  }

  _submitFormulaire(){
    this.formulaireButton.click();
  }

}

export let formulaire = new Formulaire();